<template>
  <div class="loading-spinner">
    <div class="loading-spinner__container" :class="{ background: hasBackground }">
      <div class="loading-spinner__icon" :class="size">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  hasBackground: {
    type: Boolean,
    default: true,
  },
  size: {
    type: String,
    default: 'md',
  },
})
</script>

<style lang="stylus" scoped>
.sm
  & > div:after
    top 13px
    width 3px
    height 9px

.md
  & > div:after
    top 3px
    width 5px
    height 14px


.loading-spinner
  display flex
  justify-content center
  align-items center
  &__container
    width 100px
    height 100px
    border-radius 20px
    opacity 0.8
    display flex
    justify-content center
    align-items center

    &.background
      background rgba(211, 211, 211, 0.7)

  &__icon
    color rgba(255, 255, 255, 1)
    display inline-block
    position relative
    width 64px
    height 64px
    div
      transform-origin 32px 32px
      animation loading-spinner 1.2s linear infinite
      &:after
          content " "
          display block
          position absolute
          left 29px
          border-radius 20%
          background #fff
      &:nth-child(1)
          transform rotate(0deg)
          animation-delay -1.1s
      &:nth-child(2)
          transform rotate(30deg)
          animation-delay -1s
      &:nth-child(3)
          transform rotate(60deg)
          animation-delay -0.9s
      &:nth-child(4)
          transform rotate(90deg)
          animation-delay -0.8s
      &:nth-child(5)
          transform rotate(120deg)
          animation-delay -0.7s
      &:nth-child(6)
          transform rotate(150deg)
          animation-delay -0.6s
      &:nth-child(7)
          transform rotate(180deg)
          animation-delay -0.5s
      &:nth-child(8)
          transform rotate(210deg)
          animation-delay -0.4s
      &:nth-child(9)
          transform rotate(240deg)
          animation-delay -0.3s
      &:nth-child(10)
          transform rotate(270deg)
          animation-delay -0.2s
      &:nth-child(11)
          transform rotate(300deg)
          animation-delay -0.1s
      &:nth-child(12)
          transform rotate(330deg)
          animation-delay 0s

@keyframes loading-spinner
  0%
    opacity 1
  100%
    opacity 0
</style>
